import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row } from 'reactstrap';
import { AssistanceWarrantyDTO } from "../../models/AssistanceWarranty/AssistanceWarrantyDTO";
import CheckboxComponent from "../CheckboxComponent";
import InputComponent from '../InputComponent';
import { AssistanceService } from "../../services/AssistanceService";
import Toast from "../../helpers/Toast";
import ButtonComponent from "../ButtonComponent";
import { EditAssistanceWarrantyDTO } from "../../models/AssistanceWarranty/EditAssistanceWarrantyDTO";
import { EquipmentService } from "../../services/EquipmentService";
import { EquipmentWarrantyDTO } from "../../models/Equipment/EquipmentWarrantyDTO";
import { Utilities } from "../../helpers/Utilities";
import { AssistanceDTO } from "../../models/Assistance/AssistanceDTO";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";

export type AssistanceWarrantyComponentProps = {
    assistance: AssistanceDTO | null;
    equipmentId: number;
    isComplete: boolean;
}

const AssistanceWarrantyComponent = ({ assistance, equipmentId, isComplete }: AssistanceWarrantyComponentProps) => {

    const intl = useIntl();
    const assistanceService = new AssistanceService();
    const equipmentService = new EquipmentService();
    const [warrantyFromAssistance, setWarrantyFromAssistance] = useState<AssistanceWarrantyDTO>();
    const [warrantyFromEquipment, setWarrantyFromEquipment] = useState<EquipmentWarrantyDTO>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isEditButtonLoading, setIsEditButtonLoading] = useState<boolean>(false);

    const { availableModules } = useAvailableModulesContext();
    const [isActiveWarrantySupplier, setIsActiveWarrantySupplier] = useState<boolean>(false);
    const [isActiveWarrantySeller, setIsActiveWarrantySeller] = useState<boolean>(false);

    const GetWarrantyByAssistanceId = async () => {
        setIsLoading(true);
        var response = await assistanceService.GetAssistanceWarranty(assistance?.id ?? 0);
        if (response.success === false || response.obj == null) {
            setIsLoading(false);
            Toast.Show("error", response.message);
            return;
        }
        setWarrantyFromAssistance(response.obj);
        setIsLoading(false);
    };

    const GetWarrantyByEquipmentId = async () => {
        setIsLoading(true);
        var response = await equipmentService.WarrantyDetailsFromEquipment(equipmentId);
        if (response.success === false || response.obj == null) {
            setIsLoading(false);
            Toast.Show("error", response.message);
            return;
        }
        setWarrantyFromEquipment(response.obj);
        setIsLoading(false);
    };

    useEffect(() => {
        if (assistance?.id && equipmentId) {
            GetWarrantyByAssistanceId()
            GetWarrantyByEquipmentId()
        }
    }, [assistance?.id, equipmentId])

    const editAssitanceWarranty = async () => {
        setIsEditButtonLoading(true);

        const updatedAssistanceWarranty: EditAssistanceWarrantyDTO = {
            docType: assistance?.erpDocType ?? "",
            serie: assistance?.erpSerie ?? "",
            number: assistance?.erpNumDoc ?? 0,
            assistanceId: assistance?.id ?? 0,
            isUnderWarranty: warrantyFromAssistance?.isUnderWarranty ?? false,
            warrantyDescription: warrantyFromAssistance?.warrantyDescription ?? null,
            considerWorkInWarranty: warrantyFromAssistance?.considerWorkInWarranty ?? false,
            considerPartsInWarranty: warrantyFromAssistance?.considerPartsInWarranty ?? false,
            considerTravelInWarranty: warrantyFromAssistance?.considerTravelInWarranty ?? false,
            supplierCampaign: warrantyFromAssistance?.supplierCampaign ?? null,
        };

        const response = await assistanceService.EditAssistanceWarranty(updatedAssistanceWarranty);
        setIsEditButtonLoading(false);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            return;
        }
        Toast.Show("success", response.message);
    };

    useEffect(() => {
        if (availableModules.includes("IsActiveWarrantySeller")) {
            setIsActiveWarrantySeller(true);
        }
        if (availableModules.includes("IsActiveWarrantySupplier")) {
            setIsActiveWarrantySupplier(true);
        }
    }, [availableModules]);

    return (
        <div>
            { }
            {(isActiveWarrantySupplier || isActiveWarrantySeller) && (
                <Row
                    style={{
                        margin: "0px",
                        marginTop: "10px",
                        padding: "0px",
                        alignItems: "flex-end",
                        alignContent: "flex-end",
                    }}
                >
                    <label style={{ margin: "0px", padding: "13px", fontSize: "15px" }}>
                        <b>
                            <FormattedMessage id="Screens.Warranty.Equipment.Title" />
                        </b>
                    </label>
                </Row>
            )}
            
            {isActiveWarrantySupplier && (
                <>
                    <label style={{ margin: "0px", padding: "13px" }}>
                        <b>
                            <FormattedMessage id="Screens.EquipmentCreate.WarrantySupplierSection" />
                        </b>
                    </label>

                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        {/* Fornecedor */}
                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%" }}
                            type="date"
                            value={warrantyFromEquipment?.warrantySupplierEndDate == null ? "" : Utilities.formatDateYYYYMMDD(new Date(warrantyFromEquipment.warrantySupplierEndDate))}
                            label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierStartDate" })}
                            readOnly={true}
                        />

                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%" }}
                            type="date"
                            value={warrantyFromEquipment?.warrantySupplierEndDate == null ? "" : Utilities.formatDateYYYYMMDD(new Date(warrantyFromEquipment.warrantySupplierEndDate))}
                            label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierEndDate" })}
                            readOnly={true}
                        />
                    </Row>

                    <Row
                        style={{
                            margin: "0px",
                            marginTop: "10px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={warrantyFromEquipment?.warrantySupplierIncludesParts}
                                disabled={true}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierIncludesParts" })}
                            />
                        </Col>

                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={warrantyFromEquipment?.warrantySupplierIncludesTravel}
                                disabled={true}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierIncludesTravel" })}
                            />
                        </Col>

                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={warrantyFromEquipment?.warrantySupplierIncludesWork}
                                disabled={true}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierIncludesWork" })}
                            />
                        </Col>
                    </Row>

                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <InputComponent
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type="textArea"
                            value={warrantyFromEquipment?.warrantySupplierDescription}
                            label={intl.formatMessage({ id: "Screens.Equipment.WarrantySupplierDescription" })}
                            readOnly={true}
                        />
                    </Row>
                </>
            )}

            {isActiveWarrantySeller && (
                <>
                    <label style={{ margin: "0px", padding: "13px" }}>
                        <b>
                            <FormattedMessage id="Screens.EquipmentCreate.WarrantySellerSection" />
                        </b>
                    </label>

                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%" }}
                            type="date"
                            value={warrantyFromEquipment?.warrantySellerStartDate == null ? "" : Utilities.formatDateYYYYMMDD(new Date(warrantyFromEquipment.warrantySellerStartDate))}
                            label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerStartDate" })}
                            readOnly={true}
                        />

                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%" }}
                            type="date"
                            value={warrantyFromEquipment?.warrantySellerEndDate == null ? "" : Utilities.formatDateYYYYMMDD(new Date(warrantyFromEquipment.warrantySellerEndDate))}
                            label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerEndDate" })}
                            readOnly={true}
                        />
                    </Row>

                    <Row
                        style={{
                            margin: "0px",
                            marginTop: "10px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={warrantyFromEquipment?.warrantySellerIncludesParts}
                                disabled={true}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerIncludesParts" })}
                            />
                        </Col>

                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={warrantyFromEquipment?.warrantySellerIncludesTravel}
                                disabled={true}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerIncludesTravel" })}
                            />
                        </Col>

                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={warrantyFromEquipment?.warrantySellerIncludesWork}
                                disabled={true}
                                label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerIncludesWork" })}
                            />
                        </Col>
                    </Row>

                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >

                        <InputComponent
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type="textArea"
                            value={warrantyFromEquipment?.warrantySellerDescription}
                            label={intl.formatMessage({ id: "Screens.Equipment.WarrantySellerDescription" })}
                            readOnly={true}
                        />
                    </Row>
                </>
            )}

            <Row style={{ margin: "1rem 0px" }}>
                <Row style={{ marginTop: '10px' }}>

                    <label style={{ margin: "0px", padding: "13px", fontSize: "15px" }}>
                        <b>
                            <FormattedMessage id="Screens.Warranty.Assistance.Title" />
                        </b>
                    </label>

                    <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                        <CheckboxComponent
                            checked={warrantyFromAssistance?.isUnderWarranty ?? false}
                            disabled={isLoading || isEditButtonLoading}
                            onChange={() => {
                                setWarrantyFromAssistance({ ...warrantyFromAssistance!, isUnderWarranty: !warrantyFromAssistance?.isUnderWarranty });
                            }}
                            style={{ display: 'flex', justifyContent: 'flex-start' }}
                            label={intl.formatMessage({ id: "Screens.AssistanceEditA.IsUnderWarranty" })}
                        />
                    </Col>

                    <Col xl={33} lg={3} md={12} sm={12} xs={12}>
                        <CheckboxComponent
                            checked={warrantyFromAssistance?.considerPartsInWarranty ?? false}
                            disabled={isLoading || isEditButtonLoading}
                            onChange={() => {
                                setWarrantyFromAssistance({ ...warrantyFromAssistance!, considerPartsInWarranty: !warrantyFromAssistance?.considerPartsInWarranty });
                            }}
                            label={intl.formatMessage({ id: "Screens.AssistanceEditA.ConsiderPartsInWarranty" })}
                        />
                    </Col>

                    <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                        <CheckboxComponent
                            checked={warrantyFromAssistance?.considerWorkInWarranty ?? false}
                            disabled={isLoading || isEditButtonLoading}
                            onChange={() => {
                                setWarrantyFromAssistance({ ...warrantyFromAssistance!, considerWorkInWarranty: !warrantyFromAssistance?.considerWorkInWarranty });
                            }}
                            label={intl.formatMessage({ id: "Screens.AssistanceEditA.ConsiderWorkInWarranty" })}
                        />
                    </Col>

                    <Col xl={3} lg={3} md={12} sm={12} xs={12}>
                        <CheckboxComponent
                            checked={warrantyFromAssistance?.considerTravelInWarranty ?? false}
                            disabled={isLoading || isEditButtonLoading}
                            onChange={() => {
                                setWarrantyFromAssistance({ ...warrantyFromAssistance!, considerTravelInWarranty: !warrantyFromAssistance?.considerTravelInWarranty });
                            }}
                            label={intl.formatMessage({ id: "Screens.AssistanceEditA.ConsiderTravelInWarranty" })}
                        />
                    </Col>
                </Row>

                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={warrantyFromAssistance?.warrantyDescription}
                    label={intl.formatMessage({ id: "Screens.AssistanceEditA.WarrantyDescription" })}
                    readOnly={isLoading || isEditButtonLoading}
                    onChange={(warrantyDescription: string) => {
                        setWarrantyFromAssistance({ ...warrantyFromAssistance!, warrantyDescription: warrantyDescription });
                    }}
                />

                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={warrantyFromAssistance?.supplierCampaign}
                    label={intl.formatMessage({ id: "Screens.AssistanceEditA.SupplierCampaign" })}
                    readOnly={isLoading || isEditButtonLoading}
                    onChange={(supplierCampaign: string) => {
                        setWarrantyFromAssistance({ ...warrantyFromAssistance!, supplierCampaign: supplierCampaign });
                    }}
                />
            </Row>

            <Row style={{ margin: "0px", padding: "0px", justifyContent: "end" }}>
                <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                    <ButtonComponent
                        style={{ width: "100%", marginTop: "10px" }}
                        text={intl.formatMessage({ id: "AssistanceEditA.Save" })}
                        onClick={() => editAssitanceWarranty()}
                        disabled={isLoading || isComplete || isEditButtonLoading}
                    />
                </Col>
            </Row>

        </div>
    )
}

export default AssistanceWarrantyComponent